import
{
    AccessOverview,
    Language,
    Log,
    NoteType,
    ProductType,
    SubscriptionOfUserResponseModel,
    Tag,
    VersionType,
    Visibility
} from "../services/api";


export interface IAppState
{
    visibilities: Visibility[];
    languages: Language[];
    allLanguages: Language[];
    noteTypes: NoteType[];
    productTypes: ProductType[];
    versionTypes: VersionType[];
    tags: Tag[];
    tagNames: string[];
    apiVersion: string;
    productView: string;
    selectedLanguage: Language | null;
    userSubscriptions: SubscriptionOfUserResponseModel[];
    logsOverview: AccessOverview[];
    logs: Log[];
    filteredLogsText: string;
    filteredLogsType: boolean;
}


export const defaultAppState: IAppState = {
    userSubscriptions: [],
    visibilities: [],
    languages: [],
    allLanguages: [],
    noteTypes: [],
    productTypes: [],
    versionTypes: [],
    tags: [],
    tagNames: [],
    apiVersion: '',
    productView: 'cards',
    logsOverview: [],
    logs: [],
    filteredLogsText: '',
    filteredLogsType: false,
    selectedLanguage: {
        id: 3,
        createdBy: undefined,
        modifiedBy: undefined,
        createdOn: undefined,
        modifiedOn: undefined,
        name: 'English',
        languageCode: 'en-GB',
    },
}
